const TitoloStudioOptions = {
    QUALSIASI: 'Qualsiasi',
    LICENZA_ELEMENTARE: 'Licenza elementare',
    LICENZA_MEDIA_INFERIORE: 'Licenza media inferiore',
    LICENZA_MEDIA_SUPERIORE: 'Licenza media superiore',
    DIPLOMA_IST_SUPERIORE: 'Diploma di istruzione secondaria superiore',
    DIPLOMA_MATURITA: 'Diploma di maturità',
    DIPLOMA_LAUREA_TRIENNALE: 'Diploma di laurea triennale',
    DIPLOMA_LAUREA_MAGISTRALE: 'Diploma di laurea magistrale',
    DIPLOMA_LAUREA_SPECIALISTICA: 'Diploma di laurea specialistica',
    DIPLOMA_MASTER: 'Diploma di master',
    DOTTORATO_RICERCA: 'Dottorato di ricerca',
    DIPLOMA_SPECIALIZZAZIONE: 'Diploma di specializzazione',
    DIPLOMA_PERFEZIONAMENTO: 'Diploma di perfezionamento',
    ABILITAZIONE_PROFESSIONALE: 'Abilitazione professionale',
    CERTIFICAZIONE_PROFESSIONALE: 'Certificazione professionale'
  };
  
  export default TitoloStudioOptions;
  